import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { Controller } from "react-hook-form";
import { useTranslate } from "../../../../../hooks/useTranslate";
import { EMERGENCY_TYPE, SIMPLE_TYPE } from "../../constants";
import "./ContactTypeField.css";

const ContactTypeField = (props) => {
    const {
        name,
        control,
        error,
    } = props;

    const { t } = useTranslate();

    return (
        <FormControl error={!!error} className="contact-type-field">
            <Controller
                name={name}
                control={control}
                render={({ field: { onChange, value } }) => (
                    <>
                        <div className="contact-type-field__label">
                            {t("responsibleAdults.contactInformation.contactType")}
                        </div>
                        <RadioGroup
                            name={name}
                            className="contact-type-field__values"
                            value={value}
                            onChange={onChange}
                        >
                            <FormControlLabel
                                value={SIMPLE_TYPE}
                                control={<Radio />}
                                className="active-toggle__label"
                                label={t("responsibleAdults.additionalContact")}
                                labelPlacement="end"
                            />
                            <FormControlLabel
                                value={EMERGENCY_TYPE}
                                control={<Radio />}
                                className="active-toggle__label"
                                label={t("responsibleAdults.emergencyContact")}
                                labelPlacement="end"
                            />
                        </RadioGroup>
                    </>
                )}
            />
            {error ? <FormHelperText>{error}</FormHelperText> : null}
        </FormControl>
    );
};

export default ContactTypeField;
